module.exports = __webpack_public_path__ + "static/media/skyIronMan.066c7145.jpg";